<div class="flxClmn f-1-0" style="min-height: 0;">
		<!--CC: description + legend of the table access symbols (reviewer check vs plan-admin star) on one line-->
		<div class="flxRow-between" style="gap: 20px; margin-bottom: 10px; align-items: center;">
			<div></div><!--padder-->
			<div class="flxRow" style="gap: 20px; font-size: 0.92em; align-items: center; flex-shrink: 0;">
				<span class="flxRow hSpace05" style="align-items: center;">
					<i class="far fa-check" style="color: green;"></i>
					<span>Reviewer of the module</span>
				</span>
				<span class="flxRow hSpace05" style="align-items: center;">
					<i class="far fa-star" style="color: green;"></i>
					<span>Full access as a plan admin</span>
				</span>
			</div>
		</div>
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="reviewersList"
			[headers]="[
				{text: 'Email', sortKey: 'email', width: '15%'},
				{text: 'Admin', sortKey: 'adminPermissions.user_role', centered: true, width: '70px'},
				{text: 'Inbound Shield', sortKey: 'inbound.enabled', centered: true},
				{text: 'Outbound Shield', sortKey: 'outbound.enabled', centered: true},
				{text: 'Simulation and Training', sortKey: 'threat_simulation.enabled', centered: true},
				{text: 'Account Takeover', sortKey: 'account_compromised.enabled', centered: true},
				{text: 'Collaboration Protection', sortKey: 'collaboration.enabled', centered: true},
				{text: 'Archive', sortKey: 'archive.enabled', centered: true},
			]"
			[cellsPrototype]="[
				{html: 'emailCell'},
				{html: 'adminCell'},
				{html: 'inboundCell'},
				{html: 'outboundCell'},
				{html: 'threatSimulationCell'},
				{html: 'accountTakeoverCell'},
				{html: 'collaborationCell'},
				{html: 'archiveCell'},
			]"
			(searchFunction)="searchReviewer($event.searchTerm, $event.activeFilters)"
			(onAnyItemSelected)="toggleReviewerExpand($event.item)"
			[filterData]="filterData"
			[cellActions]="{
				enable: true,
				selectItemActionCb: selectReviewerAction,
				initActionsFunction: showReviewerActions,
				showInRed: {enable: true, terms: [dic.CONSTANTS.reviewerPermissionsActions.delete]}
			}"
			[options]="{
				itemsNameSingular: 'user',
				defaultSortKey: 'adminPermissions.user_role',
				loadingTableFlag: loadingReviewers,
				refreshFunction: getPlanReviewers,
				exportToCsvFunction: exportReviewersCsv
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--CC: email cell with chevron indicating the row is expandable (taken from email-trace.component.html -> showLogsCell)-->
				<div *ngIf="cellId === 'emailCell'" class="flxRow hSpace05" style="align-items: center;">
					<i class="far fa-angle-right" style="transition: 0.2s;" [ngStyle]="{'transform': item.isExpanded ? 'rotate(90deg)' : 'none'}"></i>
					<span>{{item.email}}</span>
				</div>
				<!--CC: compact admin cell - only active permissions render, each with a tooltip, so the column stays narrow-->
				<!--CC: left-aligned - centering made rows with 2 vs 3 icons look ragged (QA)-->
				<div *ngIf="cellId === 'adminCell'" class="flxRow-center hSpace05 w100">
					<ng-container *ngFor="let perm of adminPermissionTypes">
						<!--CC: multi tenant view is only relevant for partner plans (plan.customer_id) - hide the icon otherwise-->
						<i *ngIf="item.adminPermissions?.[perm.field] && ((perm.field !== 'show_multi_tenant' && perm.field !== 'managed_plans_only') || gs.userInfo?.plan?.customer_id)" [ngClass]="perm.iconClass" [style.color]="perm.iconColor" [tooltip]="perm.label"></i>
					</ng-container>
				</div>
				<!--CC: module access indicator - green check when the user is a reviewer, or a green check with a crown when access is granted via plan-admin (only one, never both)-->
				<div class="flxRow-center w100">
					<ng-container *ngIf="cellId === 'inboundCell'"><ng-container *ngTemplateOutlet="moduleAccess; context: {enabled: item.inbound?.enabled, item: item}"></ng-container></ng-container>
					<ng-container *ngIf="cellId === 'outboundCell'"><ng-container *ngTemplateOutlet="moduleAccess; context: {enabled: item.outbound?.enabled, item: item}"></ng-container></ng-container>
					<ng-container *ngIf="cellId === 'threatSimulationCell'"><ng-container *ngTemplateOutlet="moduleAccess; context: {enabled: item.threat_simulation?.enabled, item: item}"></ng-container></ng-container>
					<ng-container *ngIf="cellId === 'accountTakeoverCell'"><ng-container *ngTemplateOutlet="moduleAccess; context: {enabled: item.account_compromised?.enabled, item: item}"></ng-container></ng-container>
					<ng-container *ngIf="cellId === 'collaborationCell'"><ng-container *ngTemplateOutlet="moduleAccess; context: {enabled: item.collaboration?.enabled, item: item}"></ng-container></ng-container>
					<ng-container *ngIf="cellId === 'archiveCell'"><ng-container *ngTemplateOutlet="moduleAccess; context: {enabled: item.archive?.enabled, item: item}"></ng-container></ng-container>
				</div>
				<!--CC: shared indicator template - reviewer check vs plan-admin crown-check-->
				<ng-template #moduleAccess let-enabled="enabled" let-item="item">
					<i *ngIf="enabled" class="far fa-check" style="color: green;" tooltip="Reviewer of this module"></i>
					<i *ngIf="!enabled && item.isPlanAdmin" class="far fa-star" style="color: green;" tooltip="Full access as a plan admin"></i>
				</ng-template>
			</ng-template>

			<!--CC: expandable row - shows the reviewer's configuration per type (structure taken from email-trace.component.html -> #subRow)-->
			<ng-template #subRow let-item>
				<tr class="bs-enabled" style="border-bottom: none;" *ngIf="item.isExpanded">
					<td colspan="9" style="background: white; border-bottom: solid 1px #e3e4e4;">
						<div class="flxClmn gap-2" style="padding: 7px 25px 15px; cursor: default;">
							<!--CC: toggle inline edit mode - turns the read-only check/X indicators into small toggles-->
							<div class="flxRow-end">
								<btn-c variant="text" [endIcon]="item.editConfig ? 'far fa-check' : 'far fa-pen'"
									   (action)="item.editConfig = !item.editConfig;">
									{{item.editConfig ? 'Done' : 'Modify permissions'}}
								</btn-c>
							</div>
							<!--CC: grid with auto-fill keeps a lone card on the last row at a normal column width instead of stretching (flex-grow did)-->
							<div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); gap: 15px;">
								<!--CC: Admin card - plan-admin level permissions, mirrors the Plan Admin tab in the modify popup. hidden for full admins (their admin perms can't be modified here)-->
								<div class="flxClmn gap-3" *ngIf="item.adminPermissions?.user_role !== dic.CONSTANTS.userRole.admin"
									 style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 15px;"
									 [ngStyle]="{opacity: (item.editConfig || item.adminPermissions?.enabled) ? '1' : '0.5'}">
									<!--admin header-->
									<div class="flxRow-between" style="align-items: center;">
										<div class="flxRow hSpace05" style="align-items: center;">
											<i class="far fa-user-shield"></i>
											<b>Admin</b>
										</div>
										<!--CC: read-only indicator - green check when assigned, shown when not editing-->
										<i *ngIf="!item.editConfig && item.adminPermissions?.enabled" class="far fa-check" style="color: green; flex-shrink: 0;" tooltip="Full access as a plan admin"></i>
										<!--CC: edit mode - toggle to grant/revoke admin-->
										<span *ngIf="item.editConfig" style="flex-shrink: 0; width: 26px; height: 24px; display: inline-flex; align-items: center; justify-content: center; overflow: visible;">
											<toggle-switch-c style="transform: scale(0.5); transform-origin: center;"
															 [hideText]="true"
															 [(model)]="item.adminPermissions.enabled"
															 (onChange)="modifyAdminPermission(item, 'enabled')"></toggle-switch-c>
										</span>
									</div>
									<!--admin sub-permissions (read only / multi tenant view)-->
									<div class="flxClmn gap-1" style="margin-top: 2px;">
										<ng-container *ngFor="let perm of adminPermissionTypes">
											<!--CC: multi tenant view is only relevant for partner plans (plan.customer_id)-->
											<div class="flxRow hSpace05" style="align-items: center;" *ngIf="perm.field !== 'enabled' && ((perm.field !== 'show_multi_tenant' && perm.field !== 'managed_plans_only') || gs.userInfo?.plan?.customer_id)">
												<!--CC: read-only indicator - shown when not editing-->
												<i *ngIf="!item.editConfig" class="far" style="flex-shrink: 0; width: 14px; text-align: center;" [ngClass]="item.adminPermissions?.[perm.field] ? 'fa-check' : 'fa-times'"
												   [ngStyle]="{color: item.adminPermissions?.[perm.field] ? 'green' : 'red'}"></i>
												<!--CC: edit mode - small toggle for the admin sub-permission (disabled until admin is granted)-->
												<span *ngIf="item.editConfig" style="flex-shrink: 0; width: 26px; height: 24px; display: inline-flex; align-items: center; justify-content: center; overflow: visible;">
													<toggle-switch-c style="transform: scale(0.5); transform-origin: center;"
																	 [hideText]="true"
																	 [isDisabled]="!item.adminPermissions?.enabled || (perm.field === 'show_multi_tenant' && item.adminPermissions?.managed_plans_only)"
																	 [(model)]="item.adminPermissions[perm.field]"
																	 (onChange)="modifyAdminPermission(item, perm.field)"></toggle-switch-c>
												</span>
												<span style="font-size: 0.9em; white-space: normal;">{{perm.label}}</span>
												<i style="font-weight: 400; font-size: 0.9em; margin-left: auto; padding: 0 2px;" class="far fa-question-circle" *ngIf="perm.description" [tooltip]="perm.description"></i>
											</div>
										</ng-container>
									</div>
								</div>
								<!--CC: one card per reviewer type. disabled types are dimmed via opacity (no grey background)-->
								<div class="flxClmn gap-3" *ngFor="let type of reviewerTypes"
									 style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 15px;"
									 [ngStyle]="{opacity: (item.editConfig || item[type.key]?.enabled || item.isPlanAdmin) ? '1' : '0.5'}">
									<!--type header-->
									<div class="flxRow-between" style="align-items: center;">
										<div class="flxRow hSpace05" style="align-items: center;">
											<i [ngClass]="type.iconClass" *ngIf="type.iconClass"></i>
											<span *ngIf="type.iconSvgName"
												  style="display: inline-block; vertical-align: middle; width: 16px; height: 16px; background: #081334; mask-repeat: no-repeat; -webkit-mask-repeat: no-repeat; mask-size: contain; -webkit-mask-size: contain;"
												  [ngStyle]="{'mask-image': 'url(\'../../images/' + type.iconSvgName + '\')', '-webkit-mask-image': 'url(\'../../images/' + type.iconSvgName + '\')'}"></span>
											<b>{{type.display}}</b>
										<i style="font-weight: 400; padding: 0 2px;" class="far fa-question-circle" *ngIf="type.description" [tooltip]="type.description"></i>
										</div>
										<!--CC: read-only indicator - green check when assigned, shown when not editing-->
										<i *ngIf="!item.editConfig && item[type.key]?.enabled" class="far fa-check" style="color: green; flex-shrink: 0;" tooltip="Reviewer of this module"></i>
										<!--CC: read-only indicator - green star when access is granted via plan-admin (not a reviewer of this module), mirrors the collapsed cell moduleAccess template-->
										<i *ngIf="!item.editConfig && !item[type.key]?.enabled && item.isPlanAdmin" class="far fa-star" style="color: green; flex-shrink: 0;" tooltip="Full access as a plan admin"></i>
										<!--CC: edit mode - small toggle to assign/unassign the module (scaled down via transform since the toggle has no size input)-->
										<span *ngIf="item.editConfig" style="flex-shrink: 0; width: 26px; height: 24px; display: inline-flex; align-items: center; justify-content: center; overflow: visible;">
											<toggle-switch-c style="transform: scale(0.5); transform-origin: center;"
															 [hideText]="true"
															 [(model)]="item[type.key].enabled"
															 (onChange)="modifyReviewerPermission(item, type.key)"></toggle-switch-c>
										</span>
									</div>
									<!--type permissions-->
									<div class="flxClmn gap-1" *ngIf="type.permissions.length" style="margin-top: 2px;">
										<div class="flxRow hSpace05" style="align-items: center;" *ngFor="let permission of type.permissions">
											<!--CC: read-only indicator - shown when not editing-->
											<i *ngIf="!item.editConfig" class="far" style="flex-shrink: 0; width: 14px; text-align: center;" [ngClass]="(item[type.key]?.[permission.field] || (!item[type.key]?.enabled && item.isPlanAdmin)) ? 'fa-check' : 'fa-times'"
											   [ngStyle]="{color: (item[type.key]?.[permission.field] || (!item[type.key]?.enabled && item.isPlanAdmin)) ? 'green' : 'red'}"></i>
											<!--CC: edit mode - small toggle for the sub-permission (disabled until the module is assigned)-->
											<span *ngIf="item.editConfig" style="flex-shrink: 0; width: 26px; height: 24px; display: inline-flex; align-items: center; justify-content: center; overflow: visible;">
												<toggle-switch-c style="transform: scale(0.5); transform-origin: center;"
																 [hideText]="true"
																 [isDisabled]="!item[type.key]?.enabled"
																 [(model)]="item[type.key][permission.field]"
																 (onChange)="modifySubPermission(item, type, permission)"></toggle-switch-c>
											</span>
											<span style="font-size: 0.9em; white-space: normal;">{{permission.label}}</span>
										<i style="font-weight: 400; font-size: 0.9em; margin-left: auto; padding: 0 2px;" class="far fa-question-circle" *ngIf="permission.description" [tooltip]="permission.description"></i>
										</div>
									</div>
									<span *ngIf="!type.permissions.length" style="font-size: 0.9em; color: grey; font-style: italic;">No sub-permissions</span>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</ng-template>

			<div tableButtons>
				<btn-c (action)="openAddReviewerWizard();"
					   endIcon="far fa-plus">
					Add Plan Reviewer
				</btn-c>
			</div>
		</trustifi-table-c>
	</div>
<!--CC: Add Reviewer wizard-->
<popup-c *ngIf="addReviewerPopup?.show"
		 head="Add Reviewers Wizard"
		 class="bs-enabled"
		 size="large"
		 (closeCb)="addReviewerPopup = null;">
	<div class="flxClmn f-1-0" style="overflow: auto;">
		<div class="steps-container" style="font-size: 0.8rem; margin-bottom: 15px;">
			<div class="step-tab" [ngClass]="{'active' : addReviewerPopup.step === 1}">Select Users</div>
			<div class="step-tab" [ngClass]="{'active' : addReviewerPopup.step === 2}">Select Reviewer Types</div>
		</div>

		<!--Step 1: select users (multi-select)-->
		<div class="flxClmn f-1-0" style="overflow: auto;" *ngIf="addReviewerPopup.step === 1">
			<loader class="d-flex centralize f-1-0 opacity-75" *ngIf="addReviewerPopup.loadingUsers"></loader>
			<trustifi-table-c *ngIf="!addReviewerPopup.loadingUsers"
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="addReviewerPopup.users"
				[headers]="[
					{text: 'Name', sortKey: 'name'},
					{text: 'Email', sortKey: 'email'},
				]"
				[cellsPrototype]="[
					{textKey: 'name'},
					{textKey: 'email'},
				]"
				[options]="{
					itemsNameSingular: 'user',
					defaultSortKey: 'email',
					showRadioButtons: true
				}"
				(searchFunction)="searchWizardUsers($event.searchTerm)">
			</trustifi-table-c>
		</div>

		<!--Step 2: select reviewer types (checkboxes) - selecting a type reveals its permission fields-->
		<div class="flxClmn gap-3" *ngIf="addReviewerPopup.step === 2">
			<div class="list-group list-group-flush settings-list-container">
				<!--CC: Admin section - grants plan-admin (mirrors the Admin card in the expandable row). shown first, like the sub-row-->
				<div class="list-group-item settings-list-item py-3 flxRow" style="justify-content: space-between; align-items: center;">
					<!--CC: label + description tooltip grouped on the left, like the expanded-row header-->
					<div class="flxRow hSpace05" style="align-items: center;">
						<checkbox class="transparent-box success-color"
								  [(model)]="adminWizardSection.selected"
								  (modelChange)="adminWizardSection.expanded = adminWizardSection.expanded || adminWizardSection.selected">
							<i class="me-2" [ngClass]="adminWizardSection.iconClass"></i>
							<span class="fw-500">{{adminWizardSection.display}}</span>
						</checkbox>
						<i style="font-weight: 400; margin-left: 6px; padding: 0 2px;" class="far fa-question-circle" *ngIf="adminWizardSection.description" [tooltip]="adminWizardSection.description"></i>
					</div>
					<i class="far cursor-pointer hvr-opacity"
					   [ngClass]="adminWizardSection.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
					   *ngIf="adminWizardSection.permissions.length"
					   (click)="adminWizardSection.expanded = !adminWizardSection.expanded"></i>
				</div>

				<!--admin sub-permissions - shown when the section is expanded-->
				<div class="list-group-item settings-list-item py-3 animated fadeIn"
					 style="background: #f9f9f9;"
					 *ngIf="adminWizardSection.expanded && adminWizardSection.permissions.length">
					<div class="flxClmn gap-2" style="padding-left: 45px;">
						<ng-container *ngFor="let perm of adminWizardSection.permissions">
							<!--CC: multi tenant view is only relevant for partner plans (plan.customer_id)-->
							<div class="flxRow hSpace05" style="align-items: center;" *ngIf="perm.field !== 'show_multi_tenant' || gs.userInfo?.plan?.customer_id">
								<checkbox class="transparent-box success-color"
										  [isDisabled]="!adminWizardSection.selected"
										  [(model)]="perm.selected">
									<span>{{perm.label}}</span>
								</checkbox>
								<i style="font-weight: 400; font-size: 0.9em; padding: 0 2px; margin-left: auto; margin-right: -6px;" class="far fa-question-circle" *ngIf="perm.description" [tooltip]="perm.description"></i>
							</div>
						</ng-container>
					</div>
				</div>

				<ng-container *ngFor="let type of reviewerTypes">
					<div class="list-group-item settings-list-item py-3 flxRow" style="justify-content: space-between; align-items: center;"
						 [ngStyle]="{opacity: moduleEnabled[type.key] ? '1' : '0.6'}">
						<!--CC: label + description tooltip grouped on the left, like the expanded-row header-->
						<div class="flxRow hSpace05" style="align-items: center;">
							<checkbox class="transparent-box success-color"
									  [isDisabled]="!moduleEnabled[type.key]"
									  [(model)]="type.selected"
									  (modelChange)="type.expanded = type.expanded || type.selected">
								<i class="me-2" [ngClass]="type.iconClass" *ngIf="type.iconClass"></i>
								<span class="me-2" *ngIf="type.iconSvgName"
									  style="display: inline-block; vertical-align: middle; width: 16px; height: 16px; background: #081334; mask-repeat: no-repeat; -webkit-mask-repeat: no-repeat; mask-size: contain; -webkit-mask-size: contain;"
									  [ngStyle]="{'mask-image': 'url(\'../../images/' + type.iconSvgName + '\')', '-webkit-mask-image': 'url(\'../../images/' + type.iconSvgName + '\')'}"></span>
								<span class="fw-500">{{type.display}}</span>
							</checkbox>
							<i style="font-weight: 400; margin-left: 6px; padding: 0 2px;" class="far fa-question-circle" *ngIf="type.description" [tooltip]="type.description"></i>
						</div>
						<!--CC: clear indication that the module is not enabled in the plan-->
						<span *ngIf="!moduleEnabled[type.key]" class="flxRow hSpace05" style="align-items: center; font-size: 0.92em; color: #b5850c; font-weight: 500;">
							<i class="far fa-exclamation-triangle"></i>
							<span>Not enabled in your plan</span>
						</span>
						<i class="far cursor-pointer hvr-opacity"
						   [ngClass]="type.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
						   *ngIf="type.permissions.length && moduleEnabled[type.key]"
						   (click)="type.expanded = !type.expanded"></i>
					</div>

					<!--type fields - shown when the section is expanded-->
					<div class="list-group-item settings-list-item py-3 animated fadeIn"
						 style="background: #f9f9f9;"
						 *ngIf="type.expanded && type.permissions.length">
						<div class="flxClmn gap-2" style="padding-left: 45px;">
							<div class="flxRow hSpace05" style="align-items: center;" *ngFor="let permission of type.permissions">
								<checkbox class="transparent-box success-color"
										  [isDisabled]="!type.selected"
										  [(model)]="permission.selected">
									<span>{{permission.label}}</span>
								</checkbox>
								<i style="font-weight: 400; font-size: 0.9em; margin-left: auto; margin-right: -6px; padding: 0 2px;" class="far fa-question-circle" *ngIf="permission.description" [tooltip]="permission.description"></i>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<!--footer-->
	<div class="flxRow-end gap-2" style="margin-top: 15px;">
		<btn-c class="popup-action-btn" variant="outlined" (action)="addReviewerPopup = null;">Cancel</btn-c>
		<btn-c class="popup-action-btn" *ngIf="addReviewerPopup.step === 2" variant="outlined" (action)="addReviewerPopup.step = 1;">Back</btn-c>
		<btn-c class="popup-action-btn" *ngIf="addReviewerPopup.step === 1" (action)="goToReviewerTypesStep();">Next</btn-c>
		<btn-c class="popup-action-btn" *ngIf="addReviewerPopup.step === 2" [loading]="addReviewerPopup.inProcess" (action)="submitNewReviewer();">Add Reviewer</btn-c>
	</div>
</popup-c>
